"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmLeavingDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _useTranslations_simplifiedRegistrationBrandPartner = require("../../hooks/useTranslations_simplified-registration-BrandPartner");
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const StyledFeedbackDialog = (0, _mui.styled)(_components.FeedbackDialog)(({
  theme
}) => ({
  '& .MuiPaper-root': {
    maxWidth: '600px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
      position: 'absolute',
      bottom: 0,
      margin: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    }
  }
}));
const ButtonDelete = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  background: theme.palette.error.main,
  color: theme.palette.default.contrastText,
  maxWidth: '330px',
  '&:hover, &:focus': {
    background: theme.palette.error.main,
    color: theme.palette.default.contrastText
  }
}));
const ButtonCancel = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  textDecoration: 'underline',
  maxWidth: '330px',
  '&:hover, &:focus': {
    background: 'inherit',
    textDecoration: 'underline',
    boxShadow: 'none'
  }
}));
const children = () => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
    variant: "body1",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      id: _models.TranslationKey.ModalLeavigInfo,
      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ModalLeavigInfo
    })
  })
});
const withConfirm = WrappedComponent => props => {
  const {
    opened,
    handleConfirm,
    handleCancel
  } = props;
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledFeedbackDialog, {
    hideCloseButton: true,
    color: "error",
    severity: "error",
    header: formatMessage(_models.TranslationKey.ModalLeavingTitle),
    open: opened,
    maxWidth: "474px",
    sx: {
      zIndex: 10
    },
    actions: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonDelete, {
      fullWidth: true,
      onClick: handleConfirm,
      ...getTestIdProps('confirm-delete-dialog-btn-confirm'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.BtnLeaving,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.BtnLeaving
      })
    }, "accept"), /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonCancel, {
      fullWidth: true,
      onClick: handleCancel,
      ...getTestIdProps('confirm-delete-dialog-btn-cancel'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.BtnCancel,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.BtnCancel
      })
    }, "cancel")],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(WrappedComponent, {
      ...props
    })
  });
};
const ConfirmLeavingDialog = exports.ConfirmLeavingDialog = withConfirm(children);